module.exports = __webpack_public_path__ + "img/jk3.3876a5c7.jpg";